<script>
  import ApplicationLayout from "../layouts/Application.svelte";

  let props = $props();
</script>

<!-- SVG Snippets -->
{#snippet iconChart()}
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="url(#gradient1)" />
    <path
      d="M20 44L28 36L36 40L44 28"
      stroke="white"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="20" cy="44" r="3" fill="white" />
    <circle cx="28" cy="36" r="3" fill="white" />
    <circle cx="36" cy="40" r="3" fill="white" />
    <circle cx="44" cy="28" r="3" fill="white" />
    <defs>
      <linearGradient
        id="gradient1"
        x1="0"
        y1="0"
        x2="64"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6366F1" />
        <stop offset="1" stop-color="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
{/snippet}

{#snippet iconInstagram()}
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="url(#gradientInsta)" />
    <rect
      x="16"
      y="16"
      width="32"
      height="32"
      rx="8"
      stroke="white"
      stroke-width="2.5"
    />
    <circle cx="32" cy="32" r="8" stroke="white" stroke-width="2.5" />
    <circle cx="41" cy="23" r="2" fill="white" />
    <rect
      x="24"
      y="44"
      width="16"
      height="8"
      rx="2"
      fill="white"
      fill-opacity="0.3"
    />
    <defs>
      <linearGradient
        id="gradientInsta"
        x1="0"
        y1="0"
        x2="64"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E4405F" />
        <stop offset="0.5" stop-color="#F77737" />
        <stop offset="1" stop-color="#FCAF45" />
      </linearGradient>
    </defs>
  </svg>
{/snippet}

{#snippet iconTikTok()}
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="url(#gradientTikTok)" />
    <path
      d="M35 20C35 20 37 18 40 18V24C37 24 35 26 35 26V38C35 42 32 45 28 45C24 45 21 42 21 38C21 34 24 31 28 31C29 31 30 31.5 30 31.5V37.5C30 37.5 29 37 28 37C26 37 27 39 28 39C30 39 29 37 29 36V20H35Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="gradientTikTok"
        x1="0"
        y1="0"
        x2="64"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF0050" />
        <stop offset="1" stop-color="#00F2EA" />
      </linearGradient>
    </defs>
  </svg>
{/snippet}

{#snippet iconReels()}
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="url(#gradientReels)" />
    <rect
      x="18"
      y="16"
      width="28"
      height="32"
      rx="4"
      stroke="white"
      stroke-width="2"
    />
    <polygon points="28,26 28,38 36,32" fill="white" />
    <circle cx="22" cy="20" r="2" fill="white" />
    <path d="M18 16L46 16" stroke="white" stroke-width="2" />
    <defs>
      <linearGradient
        id="gradientReels"
        x1="0"
        y1="0"
        x2="64"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8B5CF6" />
        <stop offset="1" stop-color="#EC4899" />
      </linearGradient>
    </defs>
  </svg>
{/snippet}

{#snippet iconAI()}
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="url(#gradientAI)" />
    <circle cx="32" cy="24" r="6" stroke="white" stroke-width="2" />
    <path
      d="M26 32C26 32 28 30 32 30C36 30 38 32 38 32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M20 40L24 36L28 40M36 40L40 36L44 40"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="20" cy="40" r="2" fill="white" />
    <circle cx="44" cy="40" r="2" fill="white" />
    <defs>
      <linearGradient
        id="gradientAI"
        x1="0"
        y1="0"
        x2="64"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#10B981" />
        <stop offset="1" stop-color="#06D6A0" />
      </linearGradient>
    </defs>
  </svg>
{/snippet}

{#snippet iconHashtag()}
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12L14 36M34 12L32 36M10 18H38M8 30H36"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{/snippet}

{#snippet iconBrain()}
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 4C18 4 13 9 13 15C11 16 10 18 10 20C10 22 11 24 13 25C13 31 18 36 24 36C30 36 35 31 35 25C37 24 38 22 38 20C38 18 37 16 35 15C35 9 30 4 24 4Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M20 20C20 20 22 22 24 22C26 22 28 20 28 20"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="20" cy="18" r="1" fill="currentColor" />
    <circle cx="28" cy="18" r="1" fill="currentColor" />
  </svg>
{/snippet}

{#snippet iconTrending()}
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 24L12 16L20 20L28 12L44 28"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36 28H44V20"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="40" cy="8" r="2" fill="currentColor" />
    <circle
      cx="40"
      cy="8"
      r="4"
      stroke="currentColor"
      stroke-width="1"
      opacity="0.5"
    />
  </svg>
{/snippet}

{#snippet iconArrowRight()}
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.167 10h11.666m-4.166 4.167L16.833 10l-5.166-4.167"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{/snippet}

{#snippet iconStar()}
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.66667L12.5 5.83333L17.5 6.66667L14.1667 10L15.8333 14.1667L10 12.5L4.16667 14.1667L5.83333 10L2.5 6.66667L7.5 5.83333L10 1.66667Z"
    />
  </svg>
{/snippet}

<ApplicationLayout {...props}>
  {#snippet content({ currentUser })}
    <div class="min-h-screen bg-white">
      <!-- Navigation -->
      <nav class="relative z-10 bg-white border-b border-gray-100">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between items-center h-16">
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <h1
                  class="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent"
                >
                  SocialsTrack
                </h1>
              </div>
            </div>
            <div class="hidden md:block">
              <div class="ml-10 flex items-baseline space-x-8">
                <a
                  href="#features"
                  class="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
                  >Features</a
                >
                <a
                  href="#how-it-works"
                  class="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
                  >How it Works</a
                >
                <a
                  href="#demo"
                  class="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
                  >Live Demo</a
                >
                {#if currentUser}
                  <a
                    href="/dashboard"
                    class="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
                  >
                    Dashboard
                  </a>
                {:else}
                  <a
                    href="/login"
                    class="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
                    >Sign In</a
                  >
                  <a
                    href="/register"
                    class="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
                  >
                    Try Free
                  </a>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Hero Section -->
      <section
        class="relative bg-gradient-to-br from-indigo-50 via-white to-purple-50 pt-16 pb-20 sm:pt-24 sm:pb-28"
      >
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center">
            <h1
              class="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight"
            >
              The social media analyzer that
              <span
                class="block bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent"
              >
                actually gets it
              </span>
            </h1>
            <p
              class="mt-6 max-w-3xl mx-auto text-xl text-gray-600 leading-relaxed"
            >
              Our AI has analyzed <strong>50+ million posts</strong> to understand
              viral patterns. Drop your Instagram or TikTok username and get instant
              insights into every post, reel, story, hashtag, and hidden engagement
              pattern. We'll show you exactly why your content works (or doesn't)
              and give you the blueprint to go viral.
            </p>
            <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/register"
                class="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Analyze My Profile Free
                {@render iconArrowRight()}
              </a>
              <a
                href="#demo"
                class="inline-flex items-center px-8 py-4 border-2 border-gray-300 text-lg font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                See Live Demo
              </a>
            </div>
            <p class="mt-4 text-sm text-gray-500">
              Free analysis • 50M+ posts analyzed • Results in 15 seconds
            </p>
          </div>
        </div>
      </section>

      <!-- Stats Section -->
      <section class="py-16 bg-gray-900 text-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-2xl font-bold mb-3">
              Trusted by creators worldwide
            </h2>
            <p class="text-gray-400">
              Real data from real creators getting real results
            </p>
          </div>

          <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div
                class="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-red-400 mb-2"
              >
                50M+
              </div>
              <div class="text-sm text-gray-400">Posts Analyzed</div>
            </div>
            <div>
              <div
                class="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400 mb-2"
              >
                2.3B
              </div>
              <div class="text-sm text-gray-400">Engagement Points Tracked</div>
            </div>
            <div>
              <div
                class="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400 mb-2"
              >
                847%
              </div>
              <div class="text-sm text-gray-400">Average Growth Increase</div>
            </div>
            <div>
              <div
                class="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-400 mb-2"
              >
                156K+
              </div>
              <div class="text-sm text-gray-400">Creators Using Daily</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Platform Support Section -->
      <section class="py-16 bg-white border-b border-gray-100">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-2xl font-bold text-gray-900 mb-3">
              Complete platform coverage with surgical precision
            </h2>
            <p class="text-gray-600">
              Every post type, every metric, every algorithm signal decoded
            </p>
          </div>

          <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div class="text-center p-4">
              <div class="flex justify-center mb-3">
                {@render iconInstagram()}
              </div>
              <h3 class="font-semibold text-gray-900 mb-1">Instagram</h3>
              <p class="text-sm text-gray-600 mb-2">
                Posts, Reels, Stories, IGTV
              </p>
              <div class="text-xs text-gray-500">
                <div>• 47 engagement metrics</div>
                <div>• Hashtag performance tracking</div>
                <div>• Story-to-feed correlation</div>
              </div>
            </div>

            <div class="text-center p-4">
              <div class="flex justify-center mb-3">
                {@render iconTikTok()}
              </div>
              <h3 class="font-semibold text-gray-900 mb-1">TikTok</h3>
              <p class="text-sm text-gray-600 mb-2">Videos, Lives, Sounds</p>
              <div class="text-xs text-gray-500">
                <div>• Hook effectiveness scoring</div>
                <div>• Trending audio analysis</div>
                <div>• Completion rate optimization</div>
              </div>
            </div>

            <div class="text-center p-4">
              <div class="flex justify-center mb-3">
                {@render iconReels()}
              </div>
              <h3 class="font-semibold text-gray-900 mb-1">Reels Deep Dive</h3>
              <p class="text-sm text-gray-600 mb-2">Hooks, Trends, Music</p>
              <div class="text-xs text-gray-500">
                <div>• 15-second retention maps</div>
                <div>• Trending effect detection</div>
                <div>• Cross-platform performance</div>
              </div>
            </div>

            <div class="text-center p-4">
              <div class="flex justify-center mb-3">
                {@render iconAI()}
              </div>
              <h3 class="font-semibold text-gray-900 mb-1">AI Predictions</h3>
              <p class="text-sm text-gray-600 mb-2">Pattern Recognition</p>
              <div class="text-xs text-gray-500">
                <div>• Viral probability scoring</div>
                <div>• Audience behavior prediction</div>
                <div>• Content gap identification</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Section -->
      <section id="features" class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              We reverse-engineer viral content with scientific precision
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              Our proprietary AI models analyze 1.2TB of social media data daily
              to understand what makes content explode. Here's what we track in
              real-time:
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <!-- Instagram Specific -->
            <div
              class="bg-gradient-to-br from-pink-50 to-orange-50 p-6 rounded-2xl border border-pink-100"
            >
              <div class="flex items-center mb-4">
                <div
                  class="w-12 h-12 bg-gradient-to-r from-pink-500 to-orange-500 rounded-lg flex items-center justify-center mr-3"
                >
                  <svg
                    class="w-6 h-6 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                </div>
                <h3 class="text-xl font-bold text-gray-900">
                  Instagram Intelligence
                </h3>
              </div>
              <ul class="space-y-2 text-gray-700 text-sm">
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Engagement timing:</strong> Optimal posting windows
                    by audience timezone</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Reel algorithm signals:</strong> 23 factors that determine
                    reach</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Story impact analysis:</strong> How stories boost feed
                    performance</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Hashtag decay tracking:</strong> When hashtags lose
                    effectiveness</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Caption psychology:</strong> Word patterns that drive
                    saves</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Visual composition analysis:</strong> Colors/layouts
                    that perform</span
                  >
                </li>
              </ul>
            </div>

            <!-- TikTok Specific -->
            <div
              class="bg-gradient-to-br from-cyan-50 to-blue-50 p-6 rounded-2xl border border-cyan-100"
            >
              <div class="flex items-center mb-4">
                <div
                  class="w-12 h-12 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center mr-3"
                >
                  <svg
                    class="w-6 h-6 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
                    />
                  </svg>
                </div>
                <h3 class="text-xl font-bold text-gray-900">TikTok Mastery</h3>
              </div>
              <ul class="space-y-2 text-gray-700 text-sm">
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Watch time optimization:</strong> Frame-by-frame retention
                    analysis</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Sound trending prediction:</strong> Audio tracks before
                    they explode</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>3-second hook scoring:</strong> Mathematical engagement
                    prediction</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Share velocity tracking:</strong> Viral coefficient
                    calculation</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Optimal duration analysis:</strong> Perfect video length
                    by niche</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-cyan-500 rounded-full mr-3"></div>
                  <span
                    ><strong>For You Page signals:</strong> 31 ranking factors decoded</span
                  >
                </li>
              </ul>
            </div>

            <!-- AI Predictions -->
            <div
              class="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-2xl border border-purple-100"
            >
              <div class="flex items-center mb-4">
                <div
                  class="w-12 h-12 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-lg flex items-center justify-center mr-3"
                >
                  {@render iconBrain()}
                </div>
                <h3 class="text-xl font-bold text-gray-900">
                  AI Predictions Engine
                </h3>
              </div>
              <ul class="space-y-2 text-gray-700 text-sm">
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Viral probability:</strong> 0-100 score for each post
                    before publishing</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Audience mood prediction:</strong> Emotional state of
                    your followers</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Content gap identification:</strong> Missing topics
                    in your niche</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Competitor pattern analysis:</strong> What's working
                    in your space</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Trend forecasting:</strong> What will be viral in 7-14
                    days</span
                  >
                </li>
                <li class="flex items-center">
                  <div class="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  <span
                    ><strong>Cross-platform optimization:</strong> Adapt content
                    for maximum reach</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- Technical Specs Section -->
      <section class="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Built on enterprise-grade AI infrastructure
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              We process 1.2TB of social media data daily using custom neural
              networks trained on 50M+ viral posts
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div
              class="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100"
            >
              <div
                class="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4"
              >
                <svg
                  class="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">
                Real-Time Processing
              </h3>
              <p class="text-gray-600 text-sm">
                Analysis completes in 15 seconds using distributed computing
                across 47 data centers
              </p>
            </div>

            <div
              class="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100"
            >
              <div
                class="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4"
              >
                <svg
                  class="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">
                Machine Learning Models
              </h3>
              <p class="text-gray-600 text-sm">
                7 custom neural networks trained on engagement patterns, visual
                recognition, and NLP
              </p>
            </div>

            <div
              class="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100"
            >
              <div
                class="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4"
              >
                <svg
                  class="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">
                Data Security
              </h3>
              <p class="text-gray-600 text-sm">
                SOC 2 compliant with end-to-end encryption. Your data is never
                stored permanently
              </p>
            </div>

            <div
              class="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100"
            >
              <div
                class="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4"
              >
                <svg
                  class="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">
                Accuracy Rate
              </h3>
              <p class="text-gray-600 text-sm">
                94.7% prediction accuracy for viral content based on 6-month
                backtest validation
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- How It Works Section -->
      <section
        id="how-it-works"
        class="py-20 bg-gradient-to-br from-indigo-50 to-purple-50"
      >
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              From username to insights in 30 seconds
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              No API keys, no complicated setup. Just pure social media
              intelligence.
            </p>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <!-- Step 1 -->
            <div class="text-center">
              <div class="relative">
                <div
                  class="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6"
                >
                  1
                </div>
                <div
                  class="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-gradient-to-r from-indigo-200 to-purple-200"
                ></div>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-3">
                Drop Your Handle
              </h3>
              <p class="text-gray-600 leading-relaxed">
                Just paste your @username. We'll scan your Instagram posts,
                reels, stories, and TikTok videos instantly.
              </p>
              <div
                class="mt-4 bg-white rounded-lg p-3 border border-gray-200 text-sm text-gray-500"
              >
                @yourhandle → 🔍 Analysis starts
              </div>
            </div>

            <!-- Step 2 -->
            <div class="text-center">
              <div class="relative">
                <div
                  class="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6"
                >
                  2
                </div>
                <div
                  class="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-gradient-to-r from-indigo-200 to-purple-200"
                ></div>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-3">
                AI Goes Deep
              </h3>
              <p class="text-gray-600 leading-relaxed">
                Our algorithms analyze engagement patterns, hashtag performance,
                posting frequency, and audience behavior across your content.
              </p>
              <div
                class="mt-4 bg-white rounded-lg p-3 border border-gray-200 text-sm text-gray-500"
              >
                Analyzing 📊 Patterns found ✨
              </div>
            </div>

            <!-- Step 3 -->
            <div class="text-center">
              <div
                class="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6"
              >
                3
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-3">
                Get Your Blueprint
              </h3>
              <p class="text-gray-600 leading-relaxed">
                Receive a detailed breakdown of what's working, what's flopping,
                and exactly how to make your next post viral.
              </p>
              <div
                class="mt-4 bg-white rounded-lg p-3 border border-gray-200 text-sm text-gray-500"
              >
                Your growth strategy ready 🚀
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Specific Insights Section -->
      <section class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                The insights that actually matter
              </h2>
              <p class="text-xl text-gray-600 mb-8">
                Forget vanity metrics. We show you the data that translates to
                real growth.
              </p>

              <div class="space-y-6">
                <div class="flex items-start space-x-4">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center text-pink-600"
                  >
                    {@render iconHashtag()}
                  </div>
                  <div>
                    <h3 class="text-lg font-semibold text-gray-900 mb-2">
                      Hashtag ROI Analysis
                    </h3>
                    <p class="text-gray-600">
                      See which hashtags actually drive engagement vs. just
                      impressions. We track reach, saves, and shares per
                      hashtag.
                    </p>
                  </div>
                </div>

                <div class="flex items-start space-x-4">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600"
                  >
                    {@render iconTrending()}
                  </div>
                  <div>
                    <h3 class="text-lg font-semibold text-gray-900 mb-2">
                      Content Hook Analysis
                    </h3>
                    <p class="text-gray-600">
                      Discover which opening lines and visual hooks keep viewers
                      watching. Perfect for Reels and TikTok optimization.
                    </p>
                  </div>
                </div>

                <div class="flex items-start space-x-4">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600"
                  >
                    {@render iconBrain()}
                  </div>
                  <div>
                    <h3 class="text-lg font-semibold text-gray-900 mb-2">
                      Audience Behavior Patterns
                    </h3>
                    <p class="text-gray-600">
                      When your followers are most active, what content they
                      save vs. share, and how to trigger more meaningful
                      engagement.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="relative">
              <div
                class="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl p-8 text-white"
              >
                <h3 class="text-2xl font-bold mb-4">See it in action</h3>
                <p class="text-indigo-100 mb-6">
                  Ready to see what your content is really doing? Get your first
                  scan for free.
                </p>

                <div class="bg-white/10 rounded-lg p-4 mb-6">
                  <div class="flex items-center space-x-3 mb-3">
                    <div
                      class="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span class="text-white font-medium">Instant analysis</span>
                  </div>

                  <div class="flex items-center space-x-3 mb-3">
                    <div
                      class="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span class="text-white font-medium">No signup needed</span>
                  </div>

                  <div class="flex items-center space-x-3">
                    <div
                      class="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span class="text-white font-medium"
                      >Actionable insights</span
                    >
                  </div>
                </div>

                <a
                  href="/register"
                  class="inline-block w-full bg-white text-indigo-600 text-center py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                >
                  Scan My Profile Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Real Results Section -->
      <section class="py-20 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Real creators, real results, real proof
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              Here's what happens when you actually understand your content
              performance with surgical precision
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <!-- Result 1 -->
            <div
              class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
            >
              <div class="text-center mb-4">
                <div class="text-4xl font-bold text-pink-600 mb-1">1,847%</div>
                <div class="text-sm text-gray-500 mb-2">
                  Reel views increase in 3 weeks
                </div>
                <div
                  class="text-xs bg-pink-100 text-pink-700 px-2 py-1 rounded-full"
                >
                  Food & Lifestyle
                </div>
              </div>
              <p class="text-gray-600 mb-4 text-sm">
                "SocialsTrack showed me my hook game was completely wrong. I was
                burying the payoff. Changed my first 3 seconds to lead with the
                result and my Reels started hitting different. Last video got
                2.3M views."
              </p>
              <div class="border-t pt-4">
                <div
                  class="flex items-center justify-between text-xs text-gray-500 mb-2"
                >
                  <span>Before SocialsTrack</span>
                  <span>After SocialsTrack</span>
                </div>
                <div
                  class="flex items-center justify-between text-sm font-semibold"
                >
                  <span class="text-red-600">12K avg views</span>
                  <span class="text-green-600">234K avg views</span>
                </div>
              </div>
              <div class="flex items-center space-x-3 mt-4">
                <div
                  class="w-10 h-10 bg-gradient-to-r from-pink-400 to-red-400 rounded-full flex items-center justify-center text-white font-semibold"
                >
                  MC
                </div>
                <div>
                  <p class="font-semibold text-gray-900">Maya Chen</p>
                  <p class="text-sm text-gray-500">
                    @mayacooks • 284K followers
                  </p>
                </div>
              </div>
            </div>

            <!-- Result 2 -->
            <div
              class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
            >
              <div class="text-center mb-4">
                <div class="text-4xl font-bold text-cyan-600 mb-1">+127K</div>
                <div class="text-sm text-gray-500 mb-2">
                  Followers in 8 weeks
                </div>
                <div
                  class="text-xs bg-cyan-100 text-cyan-700 px-2 py-1 rounded-full"
                >
                  Fitness
                </div>
              </div>
              <p class="text-gray-600 mb-4 text-sm">
                "The hashtag analysis was insane. I was using #fitness and #gym
                like everyone else. SocialsTrack found micro-hashtags with 94%
                less competition but 340% higher engagement rates. Game
                changer."
              </p>
              <div class="border-t pt-4">
                <div
                  class="flex items-center justify-between text-xs text-gray-500 mb-2"
                >
                  <span>Hashtag Strategy Before</span>
                  <span>After Optimization</span>
                </div>
                <div
                  class="flex items-center justify-between text-sm font-semibold"
                >
                  <span class="text-red-600">2.3% engagement</span>
                  <span class="text-green-600">8.7% engagement</span>
                </div>
              </div>
              <div class="flex items-center space-x-3 mt-4">
                <div
                  class="w-10 h-10 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full flex items-center justify-center text-white font-semibold"
                >
                  DT
                </div>
                <div>
                  <p class="font-semibold text-gray-900">David Torres</p>
                  <p class="text-sm text-gray-500">
                    @davelifts • 483K followers
                  </p>
                </div>
              </div>
            </div>

            <!-- Result 3 -->
            <div
              class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
            >
              <div class="text-center mb-4">
                <div class="text-4xl font-bold text-purple-600 mb-1">8.2M</div>
                <div class="text-sm text-gray-500 mb-2">
                  Total TikTok views in one month
                </div>
                <div
                  class="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded-full"
                >
                  Comedy
                </div>
              </div>
              <p class="text-gray-600 mb-4 text-sm">
                "SocialsTrack's AI told me my audience was most active at 9:47
                PM on Tuesdays, not 3 PM like I thought. Posted with trending
                audio at that exact time = 5 videos over 1M views each."
              </p>
              <div class="border-t pt-4">
                <div
                  class="flex items-center justify-between text-xs text-gray-500 mb-2"
                >
                  <span>Random Posting</span>
                  <span>Optimized Timing</span>
                </div>
                <div
                  class="flex items-center justify-between text-sm font-semibold"
                >
                  <span class="text-red-600">47K avg views</span>
                  <span class="text-green-600">1.6M avg views</span>
                </div>
              </div>
              <div class="flex items-center space-x-3 mt-4">
                <div
                  class="w-10 h-10 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full flex items-center justify-center text-white font-semibold"
                >
                  AR
                </div>
                <div>
                  <p class="font-semibold text-gray-900">Alex Rodriguez</p>
                  <p class="text-sm text-gray-500">
                    @alexcomedy • 1.2M followers
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Detailed Case Study -->
          <div
            class="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 text-white"
          >
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 class="text-2xl font-bold mb-4">
                  Deep Dive: How @sarahwellness went viral
                </h3>
                <p class="text-indigo-100 mb-6">
                  Sarah had 12K followers and was stuck. Our AI analysis
                  revealed she was posting at wrong times, using oversaturated
                  hashtags, and her hook placement was killing retention.
                </p>
                <div class="space-y-4">
                  <div class="flex items-center space-x-3">
                    <div
                      class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center"
                    >
                      <span class="text-white font-bold text-sm">1</span>
                    </div>
                    <div>
                      <div class="font-semibold">Timing Optimization</div>
                      <div class="text-sm text-indigo-200">
                        Shifted posting from 2 PM to 8:30 PM based on her
                        audience's activity patterns
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center space-x-3">
                    <div
                      class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center"
                    >
                      <span class="text-white font-bold text-sm">2</span>
                    </div>
                    <div>
                      <div class="font-semibold">Hashtag Strategy Overhaul</div>
                      <div class="text-sm text-indigo-200">
                        Replaced 15 dead hashtags with 12 high-performing
                        micro-hashtags in wellness niche
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center space-x-3">
                    <div
                      class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center"
                    >
                      <span class="text-white font-bold text-sm">3</span>
                    </div>
                    <div>
                      <div class="font-semibold">Hook Restructuring</div>
                      <div class="text-sm text-indigo-200">
                        Moved the result to the first 2 seconds instead of
                        building suspense
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white/10 rounded-xl p-6">
                <h4 class="text-lg font-semibold mb-4">90-Day Results</h4>
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <div class="text-2xl font-bold text-green-400">847%</div>
                    <div class="text-sm text-indigo-200">
                      Engagement increase
                    </div>
                  </div>
                  <div>
                    <div class="text-2xl font-bold text-green-400">+156K</div>
                    <div class="text-sm text-indigo-200">New followers</div>
                  </div>
                  <div>
                    <div class="text-2xl font-bold text-green-400">2.3M</div>
                    <div class="text-sm text-indigo-200">Best Reel views</div>
                  </div>
                  <div>
                    <div class="text-2xl font-bold text-green-400">$47K</div>
                    <div class="text-sm text-indigo-200">
                      Brand deal revenue
                    </div>
                  </div>
                </div>
                <div class="mt-6 pt-4 border-t border-white/20">
                  <div class="text-sm text-indigo-200 mb-2">
                    Quote from Sarah:
                  </div>
                  <div class="italic">
                    "I wish I found SocialsTrack 2 years ago. The insights are
                    so specific and actionable. It's like having a social media
                    scientist on your team."
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Competitive Advantage Section -->
      <section class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Why SocialsTrack destroys the competition
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              Other tools show you what happened. We tell you what to do next
              and predict what will work.
            </p>
          </div>

          <div class="overflow-x-auto">
            <table
              class="w-full bg-white rounded-2xl shadow-lg overflow-hidden"
            >
              <thead
                class="bg-gradient-to-r from-indigo-600 to-purple-600 text-white"
              >
                <tr>
                  <th class="px-6 py-4 text-left font-semibold">Feature</th>
                  <th class="px-6 py-4 text-center font-semibold"
                    >SocialsTrack</th
                  >
                  <th class="px-6 py-4 text-center font-semibold text-gray-200"
                    >Later</th
                  >
                  <th class="px-6 py-4 text-center font-semibold text-gray-200"
                    >Hootsuite</th
                  >
                  <th class="px-6 py-4 text-center font-semibold text-gray-200"
                    >Buffer</th
                  >
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr>
                  <td class="px-6 py-4 font-medium text-gray-900"
                    >Viral Prediction Scoring</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >✓ AI-Powered</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                </tr>
                <tr class="bg-gray-50">
                  <td class="px-6 py-4 font-medium text-gray-900"
                    >Real-time Hashtag Performance</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >✓ Live Updates</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
                      >Limited</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
                      >Basic</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium text-gray-900"
                    >TikTok Hook Analysis</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >✓ Frame-by-Frame</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                </tr>
                <tr class="bg-gray-50">
                  <td class="px-6 py-4 font-medium text-gray-900"
                    >Competitor Intelligence</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >✓ Deep Analysis</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
                      >Basic</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
                      >Limited</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium text-gray-900"
                    >Cross-Platform Optimization</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >✓ Smart Adaptation</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-400">✗</span></td
                  >
                </tr>
                <tr class="bg-gray-50">
                  <td class="px-6 py-4 font-medium text-gray-900">Setup Time</td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="font-semibold text-green-600">15 seconds</span
                    ></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-600">30+ minutes</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-600">45+ minutes</span></td
                  >
                  <td class="px-6 py-4 text-center"
                    ><span class="text-gray-600">20+ minutes</span></td
                  >
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <!-- Demo Preview Section -->
      <section
        class="py-20 bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900 text-white"
      >
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-3xl sm:text-4xl font-bold mb-4">
              See exactly what you'll get
            </h2>
            <p class="text-xl text-gray-300 max-w-3xl mx-auto">
              Preview of actual insights from our AI analysis. This is what your
              report will look like.
            </p>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <!-- Demo Interface -->
            <div
              class="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20"
            >
              <div class="flex items-center justify-between mb-6">
                <h3 class="text-lg font-semibold">
                  Analysis Results for @foodie_sarah
                </h3>
                <div
                  class="px-3 py-1 bg-green-500/20 text-green-300 rounded-full text-sm"
                >
                  Live Analysis
                </div>
              </div>

              <div class="space-y-4">
                <div class="bg-white/5 rounded-lg p-4">
                  <div class="flex items-center justify-between mb-2">
                    <span class="text-sm text-gray-300"
                      >Viral Probability Score</span
                    >
                    <span class="text-2xl font-bold text-green-400">87/100</span
                    >
                  </div>
                  <div class="w-full bg-gray-700 rounded-full h-2">
                    <div
                      class="bg-gradient-to-r from-green-400 to-emerald-500 h-2 rounded-full"
                      style="width: 87%"
                    ></div>
                  </div>
                </div>

                <div class="bg-white/5 rounded-lg p-4">
                  <h4 class="font-semibold mb-3">
                    Top Performing Content Types
                  </h4>
                  <div class="space-y-2">
                    <div class="flex items-center justify-between">
                      <span class="text-sm"
                        >Recipe Reels with trending audio</span
                      >
                      <span class="text-green-400">+340% engagement</span>
                    </div>
                    <div class="flex items-center justify-between">
                      <span class="text-sm">Before/after food shots</span>
                      <span class="text-green-400">+127% saves</span>
                    </div>
                    <div class="flex items-center justify-between">
                      <span class="text-sm"
                        >Quick cooking tips (&lt; 30 sec)</span
                      >
                      <span class="text-green-400">+89% shares</span>
                    </div>
                  </div>
                </div>

                <div class="bg-white/5 rounded-lg p-4">
                  <h4 class="font-semibold mb-3">Optimal Posting Windows</h4>
                  <div class="grid grid-cols-2 gap-3">
                    <div class="text-center">
                      <div class="text-lg font-bold text-purple-400">
                        8:30 PM
                      </div>
                      <div class="text-xs text-gray-400">Tuesday Peak</div>
                    </div>
                    <div class="text-center">
                      <div class="text-lg font-bold text-purple-400">
                        2:15 PM
                      </div>
                      <div class="text-xs text-gray-400">Saturday Peak</div>
                    </div>
                  </div>
                </div>

                <div class="bg-white/5 rounded-lg p-4">
                  <h4 class="font-semibold mb-3">Hashtag Recommendations</h4>
                  <div class="flex flex-wrap gap-2">
                    <span
                      class="px-2 py-1 bg-blue-500/20 text-blue-300 rounded text-xs"
                      >#quickrecipes</span
                    >
                    <span
                      class="px-2 py-1 bg-blue-500/20 text-blue-300 rounded text-xs"
                      >#30minmeals</span
                    >
                    <span
                      class="px-2 py-1 bg-blue-500/20 text-blue-300 rounded text-xs"
                      >#weeknightdinner</span
                    >
                    <span
                      class="px-2 py-1 bg-red-500/20 text-red-300 rounded text-xs line-through"
                      >#foodie (oversaturated)</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- Insights Breakdown -->
            <div class="space-y-6">
              <div>
                <h3 class="text-2xl font-bold mb-4">
                  What this means for you:
                </h3>
                <div class="space-y-4">
                  <div class="flex items-start space-x-3">
                    <div
                      class="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <div class="font-semibold">High Viral Potential</div>
                      <div class="text-gray-300 text-sm">
                        Your content style has 87% chance of viral success when
                        optimized
                      </div>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div class="font-semibold">Perfect Timing Strategy</div>
                      <div class="text-gray-300 text-sm">
                        Post on Tuesday at 8:30 PM for 3.4x higher engagement
                        rates
                      </div>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.99 1.99 0 013 12V7a4 4 0 014-4z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div class="font-semibold">Hashtag Optimization</div>
                      <div class="text-gray-300 text-sm">
                        Replace 3 dead hashtags with our micro-hashtag
                        recommendations
                      </div>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
                    >
                      <svg
                        class="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                        />
                      </svg>
                    </div>
                    <div>
                      <div class="font-semibold">Content Format Gold Mine</div>
                      <div class="text-gray-300 text-sm">
                        Recipe Reels with trending audio = 340% engagement boost
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-white/10 rounded-xl p-6 border border-white/20">
                <h4 class="font-semibold mb-3">Expected Growth in 30 Days</h4>
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <div class="text-2xl font-bold text-green-400">+47K</div>
                    <div class="text-sm text-gray-400">New Followers</div>
                  </div>
                  <div>
                    <div class="text-2xl font-bold text-green-400">340%</div>
                    <div class="text-sm text-gray-400">Engagement Increase</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section
        id="demo"
        class="py-20 bg-gradient-to-r from-indigo-600 to-purple-600"
      >
        <div class="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl sm:text-4xl font-bold text-white mb-4">
            Your next viral post starts here
          </h2>
          <p class="text-xl text-indigo-100 mb-8 max-w-2xl mx-auto">
            Stop guessing. Start growing. Get the exact blueprint for your
            social media success.
          </p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/register"
              class="inline-flex items-center px-8 py-4 bg-white text-indigo-600 text-lg font-semibold rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Analyze My Profile Free
              {@render iconArrowRight()}
            </a>
            <a
              href="#features"
              class="inline-flex items-center px-8 py-4 border-2 border-white text-lg font-semibold rounded-xl text-white hover:bg-white hover:text-indigo-600 transition-all duration-200"
            >
              See All Features
            </a>
          </div>
          <p class="mt-6 text-indigo-200 text-sm">
            Free analysis • No credit card • Results in 30 seconds
          </p>
        </div>
      </section>

      <!-- Footer -->
      <footer class="bg-gray-900 py-12">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div class="col-span-1">
              <h3
                class="text-2xl font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent mb-4"
              >
                SocialsTrack
              </h3>
              <p class="text-gray-400 mb-4">
                The social media analytics tool that actually makes creators
                money.
              </p>
            </div>
            <div>
              <h4 class="text-white font-semibold mb-4">Platforms</h4>
              <ul class="space-y-2 text-gray-400">
                <li>
                  <a
                    href="/instagram"
                    class="hover:text-white transition-colors"
                    >Instagram Analytics</a
                  >
                </li>
                <li>
                  <a href="/tiktok" class="hover:text-white transition-colors"
                    >TikTok Analytics</a
                  >
                </li>
                <li>
                  <a href="/reels" class="hover:text-white transition-colors"
                    >Reels Optimizer</a
                  >
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-white font-semibold mb-4">Resources</h4>
              <ul class="space-y-2 text-gray-400">
                <li>
                  <a href="/blog" class="hover:text-white transition-colors"
                    >Growth Tips</a
                  >
                </li>
                <li>
                  <a href="/trends" class="hover:text-white transition-colors"
                    >Trending Hashtags</a
                  >
                </li>
                <li>
                  <a
                    href="/case-studies"
                    class="hover:text-white transition-colors"
                    >Success Stories</a
                  >
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-white font-semibold mb-4">Support</h4>
              <ul class="space-y-2 text-gray-400">
                <li>
                  <a href="/help" class="hover:text-white transition-colors"
                    >Help Center</a
                  >
                </li>
                <li>
                  <a href="/contact" class="hover:text-white transition-colors"
                    >Contact</a
                  >
                </li>
                <li>
                  <a href="/privacy" class="hover:text-white transition-colors"
                    >Privacy</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            class="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400"
          >
            <p>&copy; 2024 SocialsTrack. Built for creators who want to win.</p>
          </div>
        </div>
      </footer>
    </div>
  {/snippet}
</ApplicationLayout>

<style>
  /* Custom styles for smooth scrolling and transitions */
  :global(html) {
    scroll-behavior: smooth;
  }

  /* Gradient animations */
  :global(.animate-gradient) {
    background-size: 200% 200%;
    animation: gradient 3s ease infinite;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>
